"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OneInch = void 0;
const payload_encoder_1 = require("../payload-encoder");
const adapter_1 = __importDefault(require("./adapter"));
const _1inch_pool_abi_json_1 = __importDefault(require("../../abi/1inch-pool.abi.json"));
class OneInch extends adapter_1.default {
    constructor(network, web3Provider, augustus) {
        super(network, web3Provider, augustus);
        this.network = network;
        this.web3Provider = web3Provider;
        this.augustus = augustus;
    }
    static getDexData(optimalRate, name) {
        const { data: { exchange }, } = optimalRate;
        return {
            name,
            srcAmount: optimalRate.srcAmount,
            destAmount: '1',
            exchange: exchange,
        };
    }
    _swap(srcToken, destToken, data) {
        const { exchange } = data;
        const oneInchContract = new this.web3Provider.eth.Contract(_1inch_pool_abi_json_1.default, exchange);
        const swapData = oneInchContract.methods
            .swap(this.isETHAddress(srcToken) ? payload_encoder_1.NULL_ADDRESS : srcToken, this.isETHAddress(destToken) ? payload_encoder_1.NULL_ADDRESS : destToken, data.srcAmount, data.destAmount, payload_encoder_1.NULL_ADDRESS)
            .encodeABI();
        return super.swap(srcToken, destToken, data, swapData, exchange);
    }
    buildSwap(srcToken, destToken, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._swap(srcToken, destToken, data);
        });
    }
}
exports.OneInch = OneInch;
//# sourceMappingURL=1inch.js.map